/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import CardHeader from 'react-bootstrap/esm/CardHeader';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
// import InputMask from 'react-input-mask';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function DaysCard({ dayName, day, formik }) {
  const { values, handleChange } = formik;
  const dayValues = values[day];
  const { t, i18n } = useTranslation();
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');

  const calculateTimeDifference = () => {
    const time1 = dayValues.fingerprintTime1;
    const time2 = dayValues.fingerprintTime2;
    const time3 = dayValues.fingerprintTime3;
    const time4 = dayValues.fingerprintTime4;

    // وظيفة لتحويل الوقت إلى دقائق
    const convertToMinutes = (time) => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    };

    // التحقق من عدد البصمات
    if (dayValues.countFingerprint === '2' && time1 && time2) {
      // حساب الفرق بين time2 و time1
      const totalMinutes1 = convertToMinutes(time1);
      const totalMinutes2 = convertToMinutes(time2);

      const differenceInMinutes =
        totalMinutes2 >= totalMinutes1
          ? totalMinutes2 - totalMinutes1
          : 24 * 60 - totalMinutes1 + totalMinutes2;

      const hours = Math.floor(differenceInMinutes / 60)
        .toString()
        .padStart(2, '0');
      const minutes = (differenceInMinutes % 60).toString().padStart(2, '0');

      setHours(hours);
      setMinutes(minutes);
    } else if (dayValues.countFingerprint === '3' && time1 && time2 && time3 && time4) {
      // حساب الفرق بين time2 - time1 و time4 - time3
      const totalMinutes1 = convertToMinutes(time1);
      const totalMinutes2 = convertToMinutes(time2);
      const totalMinutes3 = convertToMinutes(time3);
      const totalMinutes4 = convertToMinutes(time4);

      const difference1 =
        totalMinutes2 >= totalMinutes1
          ? totalMinutes2 - totalMinutes1
          : 24 * 60 - totalMinutes1 + totalMinutes2;

      const difference2 =
        totalMinutes4 >= totalMinutes3
          ? totalMinutes4 - totalMinutes3
          : 24 * 60 - totalMinutes3 + totalMinutes4;

      const totalDifference = difference1 + difference2;

      const hours = Math.floor(totalDifference / 60)
        .toString()
        .padStart(2, '0');
      const minutes = (totalDifference % 60).toString().padStart(2, '0');

      setHours(hours);
      setMinutes(minutes);
    } else {
      // إذا لم تكن القيم متاحة أو غير متوافقة
      setHours('');
      setMinutes('');
    }
  };

  useEffect(() => {
    calculateTimeDifference();
  }, [
    dayValues.fingerprintTime1,
    dayValues.fingerprintTime2,
    dayValues.fingerprintTime3,
    dayValues.fingerprintTime4,
    dayValues.countFingerprint,
  ]);

  const renderTooltip = (props) => (
    <Tooltip id="tooltip-hours" {...props} className="border border-2 border-theme rounded-3">
      مدة الدوام: {hours}:{minutes}
    </Tooltip>
  );

  // تطبيق ابيانات على بقية الأيام
  const copyDayData = (sourceDay) => {
    const sourceData = formik.values[sourceDay];
    const updatedValues = { ...formik.values };

    const days = ['sat', 'sun', 'mon', 'tue', 'wed', 'thu', 'fri'];
    days.forEach((day) => {
      if (day !== sourceDay) {
        updatedValues[day] = { ...sourceData };
      }
    });

    formik.setValues(updatedValues);
  };

  return (
    <Card>
      <CardHeader className="fw-bold bg-theme bg-opacity-25 d-flex justify-content-between align-items-center">
        <span className="d-flex align-items-center">
          <i className="bi-calendar text-theme me-2"></i>
          {dayName}
        </span>

        <div hidden={['0', '1'].includes(dayValues.countFingerprint)}>
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            <span className="d-flex align-items-baseline" dir="ltr">
              <span className="fs-2 fw-bold text-theme">{hours}</span>
              <span className="fs-6 ms-1">:{minutes}</span>
            </span>
          </OverlayTrigger>
        </div>
      </CardHeader>
      <CardBody>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label">{t('StatusOfPermanence')}</label>
              <Form.Select
                className="form-select"
                name={`${day}.countFingerprint`}
                value={dayValues.countFingerprint || ''}
                onChange={handleChange}>
                {[
                  { value: '0', label: i18n.language === 'ar' ? 'إجــازة' : 'Off' },
                  { value: '1', label: i18n.language === 'ar' ? 'بصمة' : 'One Fingerprint' },
                  { value: '2', label: i18n.language === 'ar' ? 'بصمتــان' : 'Two Fingerprints' },
                  {
                    value: '3',
                    label: i18n.language === 'ar' ? 'أربع بصمات' : 'Four Fingerprints',
                  },
                ].map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          {dayValues.countFingerprint !== '0' && dayValues.countFingerprint !== '1' && (
            <>
              <div className="col-xl-3">
                <div className="form-group mb-3 ">
                  {/* <label className="form-label">&nbsp;</label> */}
                  <Form.Check
                    style={{ margin: '10px 20px' }}
                    type="checkbox"
                    label={t('ExtraDay')}
                    name={`${day}.isExtraDay`}
                    value={dayValues.isExtraDay || false}
                    checked={dayValues.isExtraDay || false}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-xl-3">
                <div className="form-group mb-3">
                  {/* <label className="form-label">&nbsp;</label> */}
                  <Form.Check
                    style={{ margin: '10px 20px' }}
                    type="checkbox"
                    label={t('دوام مـــرن')}
                    // label={t('Flexible')}
                    name={`${day}.isFlexible`}
                    value={dayValues.isFlexible || false}
                    checked={dayValues.isFlexible || false}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        {/* //سماح دخول وخروج  */}
        <div
          className="row"
          hidden={
            dayValues.isFlexible ||
            dayValues.countFingerprint === '1' ||
            dayValues.countFingerprint === '0'
          }>
          <div className="col-xl-6">
            <div className="input-group mb-3 ">
              <span className="input-group-text"> سماح الدخول (بالدقيـقة)</span>

              <Form.Control
                type="number"
                className="form-control"
                name={`${day}.allowIn`}
                value={dayValues.allowIn || 0}
                // onChange={handleChange}
                onInput={(e) => {
                  const inputValue = parseInt(e.target.value, 10);

                  if (inputValue > 1438) {
                    e.target.value = 1438; // ضبط القيمة القصوى
                  }

                  handleChange(e); // استدعاء دالة التغيير
                }}
              />
            </div>
          </div>

          <div className="col-xl-6">
            <div className="input-group mb-3 ">
              <span className="input-group-text"> سماح الخروج (بالدقيـقة)</span>

              <Form.Control
                type="number"
                className="form-control"
                name={`${day}.allowOut`}
                value={dayValues.allowOut || 0}
                // onChange={handleChange}
                onInput={(e) => {
                  const inputValue = parseInt(e.target.value, 10);

                  if (inputValue > 1438) {
                    e.target.value = 1438; // ضبط القيمة القصوى
                  }

                  handleChange(e); // استدعاء دالة التغيير
                }}
              />
            </div>
          </div>
        </div>

        {dayValues.countFingerprint === '1' && (
          <div className="row">
            <div className="col-xl-6">
              <div className="input-group mb-3">
                <span className="input-group-text">{t('بداية التفعيـل')}</span>
                <Form.Control
                  type="time"
                  className="form-control"
                  name={`${day}.startIn`}
                  value={dayValues.startIn || ''}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="col-xl-6">
              <div className="input-group mb-3">
                <span className="input-group-text">{t('نهاية التفعيـل')}</span>
                <Form.Control
                  type="time"
                  className="form-control"
                  name={`${day}.endOut`}
                  value={dayValues.endOut || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        )}

        {/* 'الفترة الأولى' */}
        {(dayValues.countFingerprint === '2' || dayValues.countFingerprint === '3') && (
          <div className=" bg-inverse bg-opacity-10 p-2 rounded-3 mb-3">
            <h6 className="fw-bold">
              <i className="bi bi-clock-history me-2"></i>
              {t('الفترة الأولى')}
            </h6>
            <div className="row">
              <div className="col-xl-6">
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('OneFingerprint')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.fingerprintTime1`}
                    value={dayValues.fingerprintTime1}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('TowFingerprint')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.fingerprintTime2`}
                    value={dayValues.fingerprintTime2}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className={
                  dayValues.isExtraDay && dayValues.countFingerprint === '2'
                    ? 'col-xl-5'
                    : 'col-xl-6'
                }>
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('بداية التفعيـل')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.startIn`}
                    value={dayValues.startIn || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div
                className={
                  dayValues.isExtraDay && dayValues.countFingerprint === '2'
                    ? 'col-xl-7'
                    : 'col-xl-6'
                }>
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('نهاية التفعيـل')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.endOut`}
                    value={dayValues.endOut || ''}
                    onChange={handleChange}
                  />
                  <span
                    className="input-group-text bg-theme bg-opacity-25"
                    hidden={!dayValues.isExtraDay || dayValues.countFingerprint !== '2'}>
                    {t('اليوم التالي')}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-6 m-auto" hidden={!dayValues.isFlexible}>
                <div className="input-group mb-3 ">
                  <span className="input-group-text"> أقل مدة (بالدقيـقة) </span>

                  <Form.Control
                    type="number"
                    className="form-control"
                    name={`${day}.startFlexible`}
                    value={dayValues.startFlexible || 0}
                    // onChange={handleChange}
                    onInput={(e) => {
                      const inputValue = parseInt(e.target.value, 10);

                      if (inputValue > 1438) {
                        e.target.value = 1438; // ضبط القيمة القصوى
                      }

                      handleChange(e); // استدعاء دالة التغيير
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 'الفترة الثانيـة */}
        {dayValues.countFingerprint === '3' && (
          <div className=" bg-inverse bg-opacity-10 p-2 rounded-3 mb-3">
            <h6 className="fw-bold">
              <i className="bi bi-clock-history me-2"></i>
              {t('الفترة الثانيـة')}
            </h6>
            <div className="row">
              <div className="col-xl-6">
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('ThreeFingerprint')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.fingerprintTime3`}
                    value={dayValues.fingerprintTime3 || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-xl-6">
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('FourFingerprint')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.fingerprintTime4`}
                    value={dayValues.fingerprintTime4 || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className={dayValues.isExtraDay ? 'col-xl-5' : 'col-xl-6'}>
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('بداية التفعيـل')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.startIn2`}
                    value={dayValues.startIn2 || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className={dayValues.isExtraDay ? 'col-xl-7' : 'col-xl-6'}>
                <div className="input-group mb-3 ">
                  <span className="input-group-text">{t('نهاية التفعيـل')}</span>
                  <Form.Control
                    type="time"
                    className="form-control"
                    name={`${day}.endOut2`}
                    value={dayValues.endOut2 || ''}
                    onChange={handleChange}
                  />
                  <span
                    className="input-group-text bg-theme bg-opacity-25"
                    hidden={!dayValues.isExtraDay}>
                    {t('اليوم التالي')}
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-6 m-auto" hidden={!dayValues.isFlexible}>
                <div className="input-group mb-3 ">
                  <span className="input-group-text">أقل مدة (بالدقيـقة) </span>

                  <Form.Control
                    type="number"
                    className="form-control"
                    name={`${day}.endFlexible`}
                    value={dayValues.endFlexible || 0}
                    // onChange={handleChange}
                    onInput={(e) => {
                      const inputValue = parseInt(e.target.value, 10);

                      if (inputValue > 1438) {
                        e.target.value = 1438; // ضبط القيمة القصوى
                      }

                      handleChange(e); // استدعاء دالة التغيير
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <button
          type="button"
          className="btn btn-sm btn-outline-theme ms-2"
          onClick={() => copyDayData(day)}>
          تطبيق البيانات على بقية الأيام
        </button>
      </CardBody>
    </Card>
  );
}

export default DaysCard;
